// english tranlations
export const en = {
  home: {
    title: "Welcome to Matan's Movies World!",
    subtitle: "Search for movies or Tv Shows",
    header: {
      home: "Latest",
      movies: "Movies",
      tvShows: "Tv Shows"
    },
    random: {
      title: "Latest Movies and Tv Shows of 2021",
      info: "Here is a collection of ten recommended movies and TV shows from 2021. <br /> To search for specific movies or TV shows, you can search in the top search bar."
    },
    search: {
      title: "It's your time to enjoy!",
      info: "We have found some movies and series according to your search."
    },
    card: {
      moreInfo: "More Info"
    },
    footer: {
      madeBy: "Made by Matan Yechiel © 2021"
    }
  },
  details: {
    rating: "Rating:",
    actors: "Actors:",
    genre: "Genre:",
    language: "Language:",
    country: "Country:"
  },
  general: {
    noDescription: "No Description Provided"
  },
  headers: {
    logo: {
      title: "Your Movie Guide"
    }
  },
  errors: {
    unableToSearch: "unable to execute search."
  }
}